export default __webpack_public_path__ + "static/media/me.e37cce0b.jpg";